import React from 'react';
import { TextField, Select, MenuItem, FormControl, Checkbox, FormControlLabel, FormGroup, Radio, RadioGroup, Grid } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import CustomDate from './components/CustomDate';
import { useCustomFieldState } from './hooks/useCustomFieldState';

const CustomFields = ({ boardId, cardId, field, boardPermission }) => {
    const { type: field_type, display_name, settings, value } = field || {};
    const {
        choiceValue,
        handleBlur,
        handleCheckboxChange,
        handleDateChange,
        handleKeyDown,
        handleNumberBlur,
        handleNumberChange,
        handleNumberKeyDown,
        handleRadioChange,
        handleRadioClick,
        handleSelectChange,
        handleTextChange,
        isPending,
        numberValue,
        selectedCheckboxValues,
        textValue,
    } = useCustomFieldState({
        field,
        cardId,
        boardId,
    });

    const renderField = () => {
        switch (field_type) {
            case 'text':
                return (
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        value={textValue}
                        onChange={handleTextChange}
                        onKeyDown={handleKeyDown}
                        onBlur={handleBlur}
                        className="custom-field-text"
                        inputProps={{ maxLength: 25 }}
                        disabled={!boardPermission?.can_edit_task}
                    />
                );

            case 'select':
                return (
                    <FormControl fullWidth size="small">
                        <Select
                            value={value || ''}
                            onChange={handleSelectChange}
                            disabled={!boardPermission?.can_edit_task}
                            sx={{
                                width: "100%",
                                height: "32px",
                                marginRight: "0px",
                            }}>
                            <MenuItem key={12345678987654} value={''}>
                                None
                            </MenuItem>
                            {settings?.map((option, index) => (
                                <MenuItem key={index} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                );

            case "multi_choice":
                return (
                    <FormControl component="fieldset" disabled={!boardPermission?.can_edit_task}>
                        <RadioGroup
                            className="custom-field-radio"
                            value={choiceValue || ''}
                            onChange={handleRadioChange}
                            sx={{ pointerEvents: isPending ? 'none' : 'auto' }}>
                            {settings?.map((option, index) => (
                                <FormControlLabel
                                    key={index}
                                    value={option}
                                    control={
                                        <Radio
                                            checked={choiceValue === option}
                                            onClick={() => handleRadioClick(option)}
                                        />
                                    }
                                    label={option}
                                    sx={{ pointerEvents: isPending ? 'none' : 'auto' }}
                                />
                            ))}
                        </RadioGroup>
                    </FormControl>
                );

            case "checkbox":
                return (
                    <FormControl component="fieldset" disabled={!boardPermission?.can_edit_task}>
                        <FormGroup className="custom-field-checkbox"
                            sx={{ pointerEvents: isPending ? 'none' : 'auto' }}>
                            {settings?.map((option, index) => (
                                <FormControlLabel
                                    key={index}
                                    value={option}
                                    

                                    control={
                                        <Checkbox
                                            checked={selectedCheckboxValues.includes(option)}
                                            onChange={handleCheckboxChange}
                                            name={option}
                                            value={option}
                                            sx={{ pointerEvents: isPending ? 'none' : 'auto' }}
                                        />
                                    }
                                    label={option}
                                />
                            ))}
                        </FormGroup>
                    </FormControl>
                );

            case 'date':
                return (
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <CustomDate
                            value={Number(value) === 0 ? null : value}
                            updateCardmutate={handleDateChange}
                            disabled={!boardPermission?.can_edit_task}
                        />
                    </LocalizationProvider>
                );

            case 'number':
                return (
                    <TextField
                        fullWidth
                        type="number"
                        variant="outlined"
                        size="small"
                        value={numberValue}
                        onChange={handleNumberChange}
                        onBlur={handleNumberBlur}
                        onKeyDown={handleNumberKeyDown}
                        className="custom-field-text"
                        disabled={!boardPermission?.can_edit_task}
                    />
                );

            default:
                return <div>Unsupported field type: {field_type}</div>;
        }
    };

    return (
        <div className="custom-field-container">
            <div className="box">
                <Grid item className="allocated-hours">
                    <p>{display_name}</p>
                    <div
                        className="taskdetail-sidebar-right-col">
                        {renderField()}
                    </div>
                </Grid>
            </div>
        </div>
    );
};

export default CustomFields;
